import React from "react";

import { Icon, Header } from "semantic-ui-react";

import ProfileForm from "../../components/forms/ProfileForm";
import PasswordChangeForm from "../../components/forms/PasswordChangeForm";
import NotificationsForm from "../../components/forms/NotificationsForm";

import { hasCapability, APPROVE_REIMBURSEMENTS } from "../../util/capability";

export default () => {
  return (
    <div>
      <Header as="h2">
        <Icon name="user" />
        <Header.Content>
          Profile
          <Header.Subheader>Manage your profile</Header.Subheader>
        </Header.Content>
      </Header>
      <Header dividing as="h4">
        Personal Information
      </Header>
      <ProfileForm />
      {hasCapability(APPROVE_REIMBURSEMENTS) && [
        <Header dividing as="h4" key="profile-1">
          Notification Preferences
        </Header>,
        <NotificationsForm key="profile-2" />
      ]}
      <Header dividing as="h4">
        Change Password
      </Header>
      <PasswordChangeForm />
    </div>
  );
};



// WEBPACK FOOTER //
// ./frontend/src/views/pages/ProfileView.js